<template>
    <el-dialog v-dialogDrag class="dialog" width="1100px"
               :visible.sync="dialogVisible"
               :close-on-click-modal="false"
               top="10vh" @close="close" center>
        <div slot="title">
            <div class="dialog_title">
                采购付款
            </div>
        </div>
        <div class="dialog_body">
            <el-container class="mxInfo">
                <el-main style="overflow-y: hidden;padding-bottom: 10px">
                    <div>
                        <el-form :inline="true" style="text-align: left;padding-left:10px;" label-width="120px">
                            <div>
                                <el-form-item label="账单编号" required>
                                    <el-input style="width:200px" v-model="form.billNo" readonly>
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="单据日期" required>
                                    <el-date-picker type="date" placeholder="单据日期"
                                                    style="width: 200px"
                                                    value-format="yyyy-MM-dd"
                                                    v-model="form.billDate"></el-date-picker>
                                </el-form-item>
                                <el-form-item label="项目名称">
                                    <el-input style="width:200px" v-model="form.projectName" placeholder="请输入项目名称"
                                              @click.native="selProject">
                                    </el-input>
                                </el-form-item>
                            </div>

                            <div>
                                <el-form-item label="供应商" required>
                                    <el-input style="width:200px" v-model="form.supplierName" readonly
                                              placeholder="选择供应商" @click.native="selSupplier">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="联系人">
                                    <el-input style="width:200px" v-model="form.contactName" readonly
                                              placeholder="选择供应商后自动赋值">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="联系方式">
                                    <el-input style="width:200px" v-model="form.contactTel" readonly
                                              placeholder="选择供应商后自动赋值">
                                    </el-input>
                                </el-form-item>
                            </div>

                            <div>

                                <el-form-item label="付款类型" required>
                                    <el-select v-model="form.paymentType" placeholder="请选择付款类型" style="width:200px"
                                               @change="changeType">
                                        <el-option v-for="item in typeList" :label="item.dictionaryName"
                                                   :value="item.dictionaryName" :key="item.dictionaryId"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="会计科目" required>
                                    <el-input style="width:200px" v-model="form.accTitleName" placeholder="选择会计科目"
                                              readonly
                                              @click.native="clickAccTitle">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="付款总金额">
                                    <el-input style="width:200px" v-model="form.taxTotal" readonly
                                              placeholder="根据明细自动计算">
                                    </el-input>
                                </el-form-item>
                            </div>

                            <div>
                                <el-form-item label="附件">
                                    <div style="padding: 2px 1px; width: 200px;">
                                        <el-button type="primary" size="medium" icon="el-icon-upload"
                                                   @click="uploadFile">上传
                                        </el-button>
                                        <el-button type="primary" size="medium" icon="el-icon-view" @click="showFile">查看
                                        </el-button>
                                    </div>
                                </el-form-item>
                                <el-form-item label="备注">
                                    <el-input style="width:200px" v-model="form.remark" placeholder="请输入备注">
                                    </el-input>
                                </el-form-item>
                            </div>
                        </el-form>
                    </div>
                    <div style="padding: 10px;text-align: right">
                        <el-row>
                            <el-form :inline="true" label-width="120px">
                                <el-form-item v-show="showSelectMx">
                                    <el-button type="warning" icon="el-icon-document" @click="selPayment" size="medium">
                                        选择明细
                                    </el-button>
                                </el-form-item>
                                <el-form-item v-show="showAddMx">
                                    <el-button type="warning" icon="el-icon-document" @click="addPayment" size="medium">
                                        新增明细
                                    </el-button>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="danger" icon="el-icon-delete" @click="delMx" size="medium">
                                        删除明细
                                    </el-button>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" icon="mdi mdi-content-save" @click="submit" size="medium">
                                        保存账单
                                    </el-button>
                                </el-form-item>
                            </el-form>
                        </el-row>
                    </div>

                    <div class="Xdriver"></div>

                    <div style="padding-top: 10px" v-loading="loading">
                        <ElTableEdit
                                height="480"
                                ref="editTable"
                                :data="dataList"
                                :form="form"
                                :columns="columns"
                                border
                                stripe
                                style="width: 100%"
                                :header-cell-style="headerStyle"
                                :cell-style="cellStyle"
                                :actionsFixed="true"
                                :actionsWidth="70"
                                :conf="conf">
                            <template v-slot:column-actions="{ row, $index }">
                                <el-button @click="delItem(row, $index)"
                                           type="danger" icon="el-icon-delete" size="small">
                                </el-button>
                            </template>
                        </ElTableEdit>
                    </div>

                </el-main>
            </el-container>

            <selAccTitle v-if="showAccTitle"
                         :accTitleData="accTitleData"
                         @closeDialog="closeDialog"
                         @checkRow="checkAccTitle">
            </selAccTitle>
            <selPayment v-if="showPayment"
                        :billId="billId"
                        :supplierId="supplierId"
                        @closeDialog="closeDialog"
                        @checkRow="checkPayment">
            </selPayment>

            <selSupplier v-if="showSupplier"
                         :supplierId="supplierId"
                         @closeDialog="closeDialog"
                         @checkRow="checkSupplier">
            </selSupplier>

            <fileupload v-if="showFileUpload"
                        :fileUrl="fileUrl"
                        :fileParam="fileParam"
                        :fileListUrl="fileListUrl"
                        :delFileUrl="delFileUrl"
                        :fileKey="fileKey"
                        @closeDialog="closeDialog">
            </fileupload>
            <fileDialog v-if="showFileDialog"
                        :fileParam="fileParam"
                        :fileListUrl="fileListUrl"
                        @closeDialog="closeDialog">
            </fileDialog>
            <selProject v-if="showProject"
                        :projectId="projectId"
                        @closeDialog="closeDialog"
                        @checkRow="checkProject">
            </selProject>
        </div>
    </el-dialog>
</template>

<script>
    import fileupload from '@/components/tools/fileupload/dialog'
    import fileDialog from '@/components/tools/fileupload/showDialog'
    import ElTableEdit from '@/components/element/el-table-in-edit'
    import selPayment from '@/components/page/finance/paymentsummary/selPayment'
    import selSupplier from '@/components/page/supplier/supplier/selSupplier'
    import selAccTitle from '@/components/page/finance/accountingtitle/selAccTitlePay'
    import selProject from '@/components/page/project/selProject'

    import {MessageBox} from "element-ui";

    export default {
        name: "mxInfo",
        props: ['formData'],
        components: {
            ElTableEdit,
            selPayment,
            fileupload,
            fileDialog,
            selAccTitle,
            selSupplier,
            selProject
        },
        data() {
            return {

                accTitleData: {},
                deptData: [],
                loading: false,
                showAccTitle: false,

                form: JSON.parse(JSON.stringify(this.formData)),

                billId: "",
                supplierId: "",
                showPayment: false,
                dialogVisible: true,
                dialoading: this.loading,
                showSupplier: false,
                showProject: false,
                showSelectMx: true,
                showAddMx: false,


                conf: {},
                columns: [
                    {
                        title: "序号",
                        width: "60",
                        key: "_xh",
                        type: "index",
                        fixed: true,
                    },
                    {
                        title: "选择",
                        width: "60",
                        key: "selection",
                        type: "selection",
                        fixed: true,
                    },
                    {
                        title: "账单类型",
                        width: "150",
                        key: "relaBillType",
                    },
                    {
                        title: "账单编号",
                        width: "150",
                        key: "relaBillNo",
                    },
                    {
                        title: "账单日期",
                        width: "100",
                        key: "relaBillDate",
                    },
                    {
                        title: "账单金额",
                        width: "150",
                        key: "taxTotal",
                    },
                    {
                        title: "已付款金额",
                        width: "120",
                        key: "settleTotal"
                    },
                    {
                        title: "本次付款金额",
                        width: "120",
                        key: "payTotal",
                        placeholder: "费用金额",
                        type: "number",
                        edit: true
                    },
                    {
                        title: "未付款金额",
                        width: "120",
                        key: "noSettleTotal",
                    },
                    {
                        title: "备注",
                        key: "remark",
                        width: "150",
                        edit: true,
                    },
                ],
                dataList: [],
                pageInfo: {
                    page: 1,
                    pagesize: 200,
                    pageSizes: [10, 20, 50, 100],
                    total: 0,
                },

                fileUrl: "/billfile/uploadFiles",
                fileListUrl: "/billfile/getBillFile",
                delFileUrl: "/billfile/delete",
                fileKey: "billFileId",
                fileParam: {
                    billId: this.formData.billId
                },
                showFileUpload: false,
                showFileDialog: false,
                typeList: [],
            }
        },
        watch: {
            formData: {
                handler(val) {
                    this.form = JSON.parse(JSON.stringify(val))
                    this.fileParam = {
                        billId: this.formData.billId
                    }
                    this.getListData();
                },
                deep: true,
            }
        },
        async mounted() {
            await this.getAccountTitleTree();
            this.tree_model = {
                id: this.formData.accTitleId,
                name: this.formData.accTitleName
            };
            this.getListData();
            this.getTypeList();
        },
        methods: {
            async getTypeList() {
                let param = {
                    url: "/dictionaries/list",
                    param: {
                        parentId: "e27165f5476d46dda4d67f4dc1ff2526",
                        pageSize: "100",
                        currentPage: "1",
                    }
                }
                const data = await this.$store.dispatch('pubMethod', param);
                this.typeList = data.data.varList;
            },
            async getAccountTitleTree() {
                this.dialoading = true;
                let param = {
                    url: "/accountingtitle/listZTree",
                }
                const data = await this.$store.dispatch('pubMethod', param)
                if (data.infoCode == "0") {
                    const retData = data.data.jsonStr;
                    this.treeData = retData
                }
                this.dialoading = false;
            },
            async getListData() {
                if (this.form.billId) {
                    this.loading = true;
                    let param = {
                        url: "/purchasepay/listProduct",
                        param: {
                            billId: this.form.billId,
                            limit: this.pageInfo.pagesize,
                            page: this.pageInfo.page
                        }
                    }
                    const data = await this.$store.dispatch('pubMethod', param)
                    if (data.infoCode == "0") {
                        this.dataList = data.data.data;
                        this.pageInfo.total = data.data.count;
                    }
                    this.dataList.map(item => {
                        item._edit = true
                    })
                    this.loading = false;
                }
            },

            headerStyle() {
                return "text-align:center;height:35px;line-height:35px;padding: 5px 0;background-color:#f2f2f2;border-left:1px solid #e5e6e8;border-top:1px solid #e5e6e8;border-bottom:1px solid #e5e6e8"
            },
            cellStyle() {
                return "text-align:center"
            },
            changeType() {
                this.dataList = [];
                let paymentType = this.form.paymentType;
                if (paymentType === '预付款') {
                    this.showSelectMx = false;
                    this.showAddMx = true;
                } else {
                    this.showSelectMx = true;
                    this.showAddMx = false;
                }
            },
            async submit() {
                if (this.$pub.isEmpty(this.form.paymentType)) {
                    this.$message({message: '请选择付款类型', type: 'error'});
                    return false;
                }
                if (this.$pub.isEmpty(this.form.supplierName)) {
                    this.$message({message: '请选择供应商信息', type: 'error'});
                    return false;
                }

                if (this.$pub.isEmpty(this.form.accTitleName)) {
                    this.$message({message: '请选择会计科目', type: 'error'});
                    return false;
                }

                if (this.dataList.length <= 0) {
                    this.$message({message: '请选择账单明细信息', type: 'error'});
                    return false;
                }
                if (this.$pub.isEmpty(this.form.billDate)) {
                    this.$message({message: '请选择账单日期', type: 'error'});
                    return false;
                } else {
                     /*let billDate = this.form.billDate;
                    let MonthStart = this.$store.state.loginInfo.MonthStart;
                    let MonthEnd = this.$store.state.loginInfo.MonthEnd;
                    if (billDate < MonthStart || billDate > MonthEnd) {
                        this.$message({message: '账单日期不在记账期间内', type: 'error'});
                        return false;
                    }*/
                }
                for (var i = 0; i < this.dataList.length; i++) {

                    let payTotal = this.dataList[i].payTotal;
                    let taxTotal = this.dataList[i].taxTotal;
                    let billKind = this.dataList[i].billKind;
                    let noSettleTotal = this.dataList[i].noSettleTotal;
                    if (this.$pub.isEmpty(payTotal)) {
                        this.$message({message: '请输入付款金额', type: 'error'});
                        return false;
                    }

                    if (billKind === '-1') {
                        if (parseFloat(payTotal) >= 0 || parseFloat(payTotal) < parseFloat(noSettleTotal)) {
                            this.$message({message: '付款金额不能大于未付款金额', type: 'error'});
                            return false;
                        }
                    } else {
                        if (parseFloat(payTotal) > parseFloat(noSettleTotal) && parseFloat(taxTotal) != 0) {
                            this.$message({message: '付款金额不能大于未付款金额', type: 'error'});
                            return false;
                        }
                    }
                    this.dataList[i].orderBy = i + 1;
                }
                this.form.purchasePayProductList = this.dataList;

                let param = {
                    ...this.form,
                }
                const data = await this.$sqlOpt.save.save(param, "/purchasepay/save");
                if (data.infoCode === '0') {
                    this.$message.success("操作成功");
                    this.$emit('closeDialog', this.dialogVisible);
                }
                this.loading = false;
            },
            delMx() {
                let delData = this.$refs.editTable.getSelection();
                if (delData && delData.length > 0) {
                    MessageBox.confirm('是否确认删除选中的记录, 继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(async () => {
                        delData.map(item => {
                            let index = this.dataList.findIndex(list => {
                                if (list.billProId) {
                                    return list.billProId == item.billProId
                                } else {
                                    return list.randomId == item.randomId
                                }
                            })
                            this.dataList.splice(index, 1);
                        })
                        this.form.taxTotal = this.$pub.getPayTotal(this.dataList, this.precisionTotal);
                        this.$refs.editTable.validateRow();
                    }).catch(() => {

                    })
                } else {
                    this.$message.warning("请先选择一条记录");
                }
            },
            delItem(row, index) {
                MessageBox.confirm('是否确认删除该记录, 继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    this.dataList.splice(index, 1);
                    this.form.taxTotal = this.$pub.getPayTotal(this.dataList, this.precisionTotal);
                    this.$refs.editTable.validateRow();
                }).catch(() => {

                })
            },

            addPayment() {
                if (this.$pub.isEmpty(this.form.supplierName)) {
                    this.$message.error("请先选择供应商");
                } else {
                    let newRow = {
                        a: '',
                        billKind: '2',
                        taxTotal: 0,
                        settleTotal: 0,
                        payTotal: 0,
                        noSettleTotal: 0,
                        remark: '',
                        _edit: true
                    }
                    this.dataList = this.dataList.concat(newRow);
                }
            },
            selPayment() {
                if (this.$pub.isEmpty(this.form.supplierName)) {
                    this.$message.error("请先选择供应商");
                } else {
                    this.showPayment = true;
                }
            },
            checkPayment(rows) {
                rows.map(item => {
                    item.randomId = Math.random()
                    item._edit = true;
                    item.relaBillId = item.billId;
                    item.relaBillType = item.billType;
                    item.relaBillNo = item.billNo;
                    item.relaBillDate = item.billDate;
                    if (item.billKind === '-1') {
                        item.taxTotal = item.taxTotal * -1;
                        item.settleTotal = item.settleTotal * -1;
                        item.noSettleTotal = item.noSettleTotal * -1;
                        item.payTotal = item.noSettleTotal;
                    } else {
                        item.payTotal = item.noSettleTotal;
                    }
                })
                this.dataList = this.dataList.concat(rows);

                this.form.taxTotal = this.$pub.getPayTotal(this.dataList, this.precisionTotal);
                this.showPayment = false;
            },
            selSupplier() {
                this.showSupplier = true;
                this.dataList = [];
            },
            checkSupplier(row) {
                this.form.supplierName = row.supplierName;
                this.form.contactName = row.contactName;
                this.form.contactTel = row.contactTel;
                this.form.supplierId = row.supplierId;
                this.supplierId = row.supplierId;
                this.showSupplier = false;
            },
            checkAccTitle(row) {
                this.form.accTitleId = row.id;
                this.form.accTitleName = row.name;
                this.form.accTitleCode = row.code;
                this.showAccTitle = false;
            },
            clickAccTitle() {
                this.accTitleData = this.form;
                this.showAccTitle = true;
            },

            selProject() {
                this.projectId = this.form.projectId;
                this.showProject = true;
            },
            checkProject(row) {
                this.form.projectId = row.projectId;
                this.form.projectName = row.projectName;
                this.showProject = false;
            },
            closeDialog() {
                this.showFileUpload = false;
                this.showFileDialog = false;
                this.showPayment = false;
                this.showSupplier = false;
                this.showAccTitle = false;
                this.showProject = false;
            },
            uploadFile() {
                this.showFileUpload = true;
            },
            showFile() {
                this.showFileDialog = true;
            },
            close() {
                this.$emit('closeDialog', this.dialogVisible)
            },
        }
    }
</script>

